import { type BreakoutImages } from '../../context/AllBreakoutRoomsContext';
import { getUrls } from '../../utils/url';

export const getDemoBreakoutImages = (): BreakoutImages => {
    const { vanityUrl } = getUrls();

    return {
        'Main Classroom': {
            breakout_name: 'Main Classroom',
            url: `${vanityUrl}/demo_breakout_images/main-classroom.jpg`
        },
        'Breakout Room 1': {
            breakout_name: 'Breakout Room 1',
            url: `${vanityUrl}/demo_breakout_images/room1.jpg`
        },
        'Breakout Room 2': {
            breakout_name: 'Breakout Room 2',
            url: `${vanityUrl}/demo_breakout_images/room2.jpg`
        },
        'Breakout Room 3': {
            breakout_name: 'Breakout Room 3',
            url: `${vanityUrl}/demo_breakout_images/room3.jpg`
        },
        'Breakout Room 4': {
            breakout_name: 'Breakout Room 4',
            url: `${vanityUrl}/demo_breakout_images/room4.jpg`
        }
    };
};
